(() => {
  'use strict';
  const propertyName = 'properties[_lw_p019]';

  function analyticsAllowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }

  function previewProof(value) {
    if (window.Shopify?.theme?.role === 'main') return;
    document.documentElement.dataset.lwP019Proof = JSON.stringify(value);
  }

  function recommendationContext(form) {
    const cart = form.closest('lw-cart-complements');
    if (cart) {
      return {
        origin: cart.dataset.context === 'drawer' ? 'cart-drawer' : 'cart-page',
        strategy: form.closest('.lw-cart-complement')?.querySelector('.lw-cart-complement__shipping') ? 'shipping-gap' : 'curated',
      };
    }
    const modal = form.closest('quick-add-modal');
    const recommendations = form.closest('product-recommendations.complementary-products') ||
      modal?.openedBy?.closest('product-recommendations.complementary-products');
    if (!recommendations) return null;
    return { origin: 'product-page', strategy: 'curated', source_product: recommendations.dataset.productId };
  }

  // Run before the native product form constructs FormData, including Quick Add.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    form.querySelectorAll('input[data-lw-p019]').forEach((input) => input.remove());
    delete form.dataset.lwP019;
    const context = recommendationContext(form);
    if (!context) return;
    if (!analyticsAllowed()) {
      previewProof({ status: 'analytics-not-allowed' });
      return;
    }
    const metadata = { ...context, revision: '20261017', test: window.Shopify?.theme?.role !== 'main' };
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = propertyName;
    input.value = JSON.stringify(metadata);
    input.setAttribute('data-lw-p019', '');
    form.appendChild(input);
    form.dataset.lwP019 = input.value;
    previewProof({ status: 'tagged', origin: metadata.origin, test: metadata.test });
  }, true);

  // This event is dispatched only after cart/add confirms the addition.
  document.addEventListener('lw:p019-added', (event) => {
    try {
      const metadata = JSON.parse(event.detail.metadata || 'null');
      const variant = String(event.detail.variant_id || '');
      if (!metadata || !['cart-page', 'cart-drawer'].includes(metadata.origin) || !/^\d+$/.test(variant)) {
        previewProof({ status: 'server-confirmed-without-marker' });
        return;
      }
      previewProof({ status: 'server-confirmed', origin: metadata.origin, strategy: metadata.strategy, variant_id: variant, test: metadata.test === true });
      if (!analyticsAllowed() || !window.Shopify?.analytics?.publish) return;
      const data = {
        origin: metadata.origin,
        strategy: metadata.strategy === 'shipping-gap' ? 'shipping-gap' : 'curated',
        variant_id: variant,
        quantity: 1,
        revision: '20261017',
        test: metadata.test === true,
      };
      Promise.resolve(window.Shopify.analytics.publish('lw_p019:recommendation_added', data)).catch(() => {});
    } catch (_) {}
  });

  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
})();
